import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Plus, X } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'

const QUICK_ACTIONS = [
  { icon: '📖', label: 'Journal', type: 'journal' },
  { icon: '📷', label: 'Photo', type: 'photo' },
  { icon: '🏆', label: 'Milestone', type: 'milestone' },
  { icon: '🎙', label: 'Voice', type: 'voice' },
]

export default function AddEntryFab() {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  const handleSelect = (type: string) => {
    setOpen(false)
    navigate(`/timeline/create?type=${type}`)
  }

  return (
    <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-40 flex flex-col items-center gap-3">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 16, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.95 }}
            className="flex flex-col gap-2 items-center"
          >
            {QUICK_ACTIONS.map((a, i) => (
              <motion.button
                key={a.type}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.04 }}
                onClick={() => handleSelect(a.type)}
                className="flex items-center gap-2.5 px-4 py-2.5 rounded-2xl font-medium text-sm text-white"
                style={{
                  background: 'rgba(13,15,26,0.95)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  backdropFilter: 'blur(16px)',
                  boxShadow: '0 4px 24px rgba(0,0,0,0.4)',
                }}
              >
                <span className="text-xl">{a.icon}</span>
                {a.label}
              </motion.button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        onClick={() => setOpen(!open)}
        whileTap={{ scale: 0.92 }}
        className="w-14 h-14 rounded-full flex items-center justify-center shadow-2xl"
        style={{
          background: 'linear-gradient(135deg, #4f6ef7, #8b5cf6)',
          boxShadow: '0 4px 24px rgba(79,110,247,0.4)',
        }}
      >
        <motion.div
          animate={{ rotate: open ? 45 : 0 }}
          transition={{ duration: 0.2 }}
        >
          <Plus size={26} className="text-white" strokeWidth={2.5} />
        </motion.div>
      </motion.button>
    </div>
  )
}

// YearScroller export
export { YearScroller } from '@/components/timeline/OnThisDayBanner'
